import { StyleSheet } from 'react-native';

const ResourceDownloadButtonImage = ({ style }) => {
  const oneX = require('./resource-download-button.jpg');
  const twoX = require('./resource-download-button@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={StyleSheet.flatten(style)}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceDownloadButtonImage };
